<template>
    <div>
        <div class="row justify-between q-py-xs">
            <div v-if="selectedRows.length">Групповые действия:
                <q-btn color="negative" @click="deleteDomains(selectedRows)" :disable="!isAllowedToEditMultiple(selectedRows) || !isAllowedToRemoveMultiple()">Удалить</q-btn>
            </div>
        </div>
        <q-table
                v-if="domains"
                hide-bottom
                row-key="id"
                selection="multiple"
                :data="domains"
                :columns="columns"
                :pagination.sync="pagination"
                :selected.sync="selectedRows"
                :loading="loading"
        >
            <q-td slot="body-cell-fqdn" slot-scope="props">
                <a :href="`http${props.row.ssl !== 'NONE' ? 's' : ''}://` + props.value"
                   target="_blank">{{props.value}}</a>
            </q-td>
            <q-td slot="body-cell-fqdn_status" slot-scope="props">
                <q-spinner-puff v-if="checkFqdnDeploying(props.row.fqdn_status)" color="secondary" :size="30"/>
                {{props.value}}
            </q-td>
            <q-td slot="body-cell-edit" slot-scope="props" class="text-right">
                <q-btn @click="deleteDomain(props.row)" :disable="!isAllowedToEdit(props.row) || disallowToRemove()" icon="delete" flat round
                       color="negative"/>
            </q-td>
        </q-table>
        <div class="q-mt-md">
            <q-btn @click="addDomain" label="Добавить"/>
            <q-modal v-model="modalOpened" :content-css="{width: '400px'}">
                <div class="q-pa-lg">
                    <div
                        v-for="(domain, index) in domainsToCreate"
                        :key="index"
                        class="row items-center"
                    >
                        <q-input
                            v-model="domain.fqdn"
                            stack-label="Доменное имя"
                            class="col"
                        />
                        <q-btn
                            v-if="domainsToCreate.length > 1"
                            @click="removeDomainInput(index)"
                            icon="delete"
                            flat
                            round
                            color="negative"
                        />
                    </div>
                    <q-btn
                        @click="addDomainInput"
                        label="Добавить домен"
                        flat
                        color="primary"
                        class="q-mt-sm"
                    />
                    <div class="q-mt-md row justify-end">
                        <q-btn @click="analyzeDomains" label="Сохранить" color="primary" class="q-mr-xs"/>
                        <q-btn @click="modalOpened=false" label="Отмена" flat color="primary" class="q-mr-sm"/>
                    </div>
                </div>
            </q-modal>
        </div>

      <analyze-domain
          v-if="analyzerOpened"
          :project="project"
          :opened="analyzerOpened"
          :additional-domains="additionalDomains"
          @process="processDomainAdd"
          @closed="analyzerOpened = !analyzerOpened"
      />
    </div>
</template>

<script>
import {mapState} from 'vuex';

import {
  QTable,
  QSpinner,
  QSpinnerPuff,
  QTd,
  QIcon,
  QBtn,
  QModal,
  QInput,
  QSelect
} from 'quasar';

import AnalyzeDomain from "../ProjectDomains/AnalyzeDomain";

export default {
  name: "ProjectDomains",

  components: {
    QTable,
    QTd,
    QSpinner,
    QSpinnerPuff,
    QIcon,
    QBtn,
    QModal,
    QInput,
    QSelect,
    AnalyzeDomain
  },

  /*props: {
    project: Object
  },*/

  computed: {
    ...mapState({
      project: state => state.project.data
    }),

    domains: {
      get() {
        return this.project ? this.project.domains : null
      },

      set() {
      }
    },

    projectId() {
      return this.$route.params.id;
    },

    additionalDomains() {
      return this.domainsToCreate.map(domain => domain.fqdn);
    }
  },

  updated() {
    this.domains.forEach(domain => this.pollDomain(domain));
  },

  destroyed() {
    this.clearPolling();
  },

  data() {
    return {
      columns: [
        {
          label: 'Доменное имя',
          field: 'fqdn',
          name: 'fqdn',
          sortable: false,
          align: 'left',
        },

        {
          label: 'Статус деплоя домена',
          field: 'fqdn_status',
          name: 'fqdn_status',
          sortable: false,
          align: 'left',
          format: val => {
            switch (val) {
              case 'NEW':
                return 'В очереди на добавление';
              case 'ASSIGNING':
                return 'Подключается';
              case 'ASSIGNING_ERROR':
                return 'Ошибка при подключении';
              case 'ASSIGNING_RETRY':
                return 'Ошибка. Ожидание еще одной попытки подключения';
              case 'ASSIGNED':
                return 'Подключён';
              case 'REMOVING':
                return 'Отключается';
              case 'REMOVE_RETRY':
                return 'Ошибка. Ожидание еще одной попытки отключения';
              case 'REMOVE_ERROR':
                return 'Ошибка при отключении';
              default:
                return val;
            }
          }
        },

        {
          label: 'Действия',
          field: 'id',
          name: 'edit',
          sortable: false,
          align: 'right',
        },
      ],

      pagination: {
        sortBy: 'sort_order', // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 50 // current rows per page being displayed
      },

      selectedRows: [],

      domainsToCreate: [],

      modalOpened: false,

      loading: false,

      analyzerOpened: false,

      pollingTimers: {}
    }
  },

  methods: {
    analyzeDomains() {
      const clientDomains = this.domains.filter( domain => !domain.fqdn.includes('horoshop.ua')).length;
      const sslIsEnabled = this.project.ssl;

      if(clientDomains > 0 && sslIsEnabled){
        this.modalOpened = false;
        this.analyzerOpened = true;

        return;
      }

      this.saveDomains();
    },

    addDomain() {
      this.modalOpened = true;
      this.domainsToCreate = [{fqdn: ''}];
    },

    addDomainInput() {
      this.domainsToCreate.push({fqdn: ''});
    },

    removeDomainInput(index) {
      this.domainsToCreate.splice(index, 1);
    },

    saveDomains() {
      this.modalOpened = false;
      this.$http.post(
        `api/v1.0/projects/${this.$route.params.id}/domains/multiple`,
        {domains: this.domainsToCreate}
      ).then(response => {
          this.$store.commit('project/setProjectDomains', this.domains.concat(response.data));
          this.$q.notify({message: 'Сохранено', type: 'positive'});
      }).catch(error => {
          if (error?.response?.status === 422) {
              this.$q.notify({message: 'Неправильний формат домену', type: 'negative'});
          } else {
              this.$q.notify({message: 'Ошибка', type: 'negative'});
          }
      });
    },

    deleteDomain(domain) {
      if (confirm(`Вы действительно хотите удалить домен ${domain.fqdn}?`)) {
        this.$http.delete(`api/v1.0/projects/${this.$route.params.id}/domains/${domain.id}`)
            .then(response => {
              if (response.data.fqdn) {
                this.commitDomain(response.data);
                this.$q.notify({message: 'Домен поставлен в очередь на удаление', type: 'info'});
              } else {
                this.deleteDomainFromObject(domain.id);
              }
            })
            .catch((error) => {
              console.error(error);
            });
      }
    },

    deleteDomains(domains) {
      if (confirm(`Вы действительно хотите удалить домены (${domains.length})?`)) {
        const data = {
          ids: domains.map(domain => domain.id),
        };

        this.$http.delete(`api/v1.0/projects/${this.$route.params.id}/domains`, {data})
          .then(response => {
            if (response.data) {
              this.commitDomains(response.data);
              this.$q.notify({message: 'Домены поставлены в очередь на удаление', type: 'info'});
            } else {
              this.deleteDomainsFromObject(data.ids);
            }
            this.selectedRows = [];
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    deleteDomainFromObject(id) {
      let domains = this.domains.filter(row => row.id !== id);
      this.$store.commit('project/setProjectDomains', domains);

      this.$q.notify({message: 'Домен удален', type: 'info'});
    },

    deleteDomainsFromObject(ids) {
      let domains = this.domains.filter(row => !ids.includes(row.id));
      this.$store.commit('project/setProjectDomains', domains);

      this.$q.notify({message: 'Домены удалены', type: 'info'});
    },

    processDomainAdd() {
      this.analyzerOpened = false;
      this.saveDomains();
    },

    updateDomain(domain) {
      return this.$http.get(`api/v1.0/projects/${this.$route.params.id}/domains/${domain.id}`)
          .then(response => {
            if (this.checkFqdnDeployError(response.data.fqdn_status)) {
              this.$q.dialog({
                title: `Ошибка подключения домена ${response.data.fqdn}`,
                message: `Проверьте логи проекта`,
                ok: true
              });
              this.$store.dispatch('project/fetchLogs', this.projectId);
            }

            if (this.checkFqdnRemoveError(response.data.fqdn_status)) {
              this.$store.dispatch('project/fetchLogs', this.projectId);
            }

            this.commitDomain(response.data);
          });
    },

    commitDomain(domainToCommit) {
      let domains = this.domains.map(domain => {
        if (domain.id === domainToCommit.id) {
          return ({...domain, ...domainToCommit});
        } else {
          return domain;
        }
      });

      this.$store.commit('project/setProjectDomains', domains);
    },

    commitDomains(domainsToCommit) {
      let domains = this.domains.map(domain => {
        for (const domainToCommit of domainsToCommit) {
          if (domain.id === domainToCommit.id) {
            return ({...domain, ...domainToCommit});
          }
        }

        return domain;
      });

      this.$store.commit('project/setProjectDomains', domains);
    },

    clearPolling() {
      for (let i in this.pollingTimers) {
        if (this.pollingTimers.hasOwnProperty(i)) {
          clearInterval(this.pollingTimers[i]);
          delete this.pollingTimers[i];
        }
      }
    },

    pollDomain(domain) {
      let domainId = domain.id;
      if (this.checkFqdnDeploying(domain.fqdn_status)) {
        if (!this.pollingTimers[domainId]) {
          // console.log(`Timer has been set for ${domain.fqdn}`);
          this.pollingTimers[domainId] = setInterval(() => {
            this.updateDomain(domain).catch((error) => {
              clearInterval(this.pollingTimers[domainId]);
              delete this.pollingTimers[domainId];
              this.deleteDomainFromObject(domainId);
            });
          }, 5000);
        }
      } else if (this.pollingTimers[domainId]) {
        // console.log(`Timer has been unset for ${domain.fqdn}`);
        clearInterval(this.pollingTimers[domainId]);
        delete this.pollingTimers[domainId];
      }
    },

    checkFqdnDeploying(fqdnStatus) {
      return ['ASSIGNING_ERROR', 'REMOVE_ERROR', 'ASSIGNED'].indexOf(fqdnStatus) === -1;
    },

    checkFqdnDeployError(fqdnStatus) {
      return ['ASSIGNING_ERROR'].indexOf(fqdnStatus) !== -1;
    },

    checkFqdnRemoveError(fqdnStatus) {
      return ['REMOVE_ERROR'].indexOf(fqdnStatus) !== -1;
    },

    checkSslDeploying(sslStatus) {
      return ['ASSIGNED', 'NONE', 'ASSIGNING_ERROR', 'REMOVE_ERROR'].indexOf(sslStatus) === -1;
    },

    isAllowedToEdit(domain) {
      return !this.checkFqdnDeploying(domain.fqdn_status) && !this.checkSslDeploying(domain.ssl_status);
    },

    isAllowedToEditMultiple(domains) {
      for (const domain of domains) {
        if (!this.isAllowedToEdit(domain)) {
          return false;
        }
      }

      return true;
    },

    isAllowedToRemoveMultiple() {
      return this.selectedRows.length < this.domains.length;
    },

    disallowToRemove() {
      return this.domains.length <= 1;
    }
  }
}
</script>

<style scoped>
.q-btn.disabled {
  opacity: 0.2 !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ProjectDomains/ProjectDomains.vue